import script from "./Aptitude.vue?vue&type=script&setup=true&lang=js"
export * from "./Aptitude.vue?vue&type=script&setup=true&lang=js"

import "./Aptitude.vue?vue&type=style&index=0&id=00347372&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00347372"]])

export default __exports__